export default "assets/logo-8a020a17.png";